import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CardScoreState {
  card_id: string;
  mistakes: number;
  max_score: number;
  is_completed: boolean;
}

interface ScoreTrackingState {
  byId: Record<string, CardScoreState>;
}

const initialState: ScoreTrackingState = {
  byId: {},
};

const scoreTrackingSlice = createSlice({
  name: "scoreTracking",
  initialState,
  reducers: {
    incrementMistakes: (
      state,
      action: PayloadAction<{ cardId: string; maxScore: number }>
    ) => {
      const { cardId, maxScore } = action.payload;
      const current = state.byId[cardId];
      if (current && current.is_completed) return;
      const mistakes = (current?.mistakes ?? 0) + 1;
      state.byId[cardId] = {
        card_id: cardId,
        mistakes,
        max_score: current?.max_score ?? maxScore,
        is_completed: false,
      };
    },
    finalizeCard: (
      state,
      action: PayloadAction<{
        cardId: string;
        mistakes: number;
        maxScore: number;
      }>
    ) => {
      const { cardId, mistakes, maxScore } = action.payload;
      const current = state.byId[cardId];
      if (current && current.is_completed) return;
      state.byId[cardId] = {
        card_id: cardId,
        mistakes,
        max_score: current?.max_score ?? maxScore,
        is_completed: true,
      };
    },
    resetAll: (state) => {
      state.byId = {};
    },
  },
});

export const { incrementMistakes, finalizeCard, resetAll } =
  scoreTrackingSlice.actions;

export default scoreTrackingSlice.reducer;
